/** Recognize an alert request and retain only the topic used to rank reports. */
export function searchAlertIntent(query: string): {
  alert: boolean
  topic: string
} {
  const normalized = query.trim().replace(/\s+/g, ' ')
  const phrase =
    /\b(?:alert me(?: (?:on|for|when))?|alert (?:on|for|when)|(?:set up|set|create) an alert(?: (?:on|for|when))?|new alert(?: (?:on|for|when))?|(?:notify me|warn me)(?: (?:on|for|when))?|let me know when|tell me when|email me when|slack me when)\b/i
  if (!phrase.test(normalized)) return { alert: false, topic: query }
  return {
    alert: true,
    topic: normalized
      .replace(phrase, '')
      .trim()
      .replace(/\s+/g, ' ')
      .replace(/\s+changes$/i, '')
  }
}
